// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".hive_ibv27e7{margin:32px auto;}\n.hive_t3nc7yd{font-style:normal;font-weight:normal;font-size:16px;line-height:24px;text-align:center;color:#262626;}\n.hive_c14qmxfq{-webkit-flex:1;-ms-flex:1;flex:1;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column;-webkit-box-pack:end;-webkit-justify-content:flex-end;-ms-flex-pack:end;justify-content:flex-end;}\n", ""]);
// Exports
module.exports = exports;
